import React, { useState, useEffect } from "react";
import MaterialTable from "material-table";
import Axios from "axios";
import DatePicker from "react-datepicker";
import Select from "react-select-virtualized";
import {
  MDBRow,
  MDBCol,
  MDBContainer,
  MDBIcon,
  MDBModal,
  MDBCard,
  MDBCardBody,
  MDBCardHeader,
  MDBCardFooter,
  MDBBtn,
  MDBBtnGroup,
  MDBTooltip,
  MDBJumbotron,
} from "mdbreact";
import { toast } from "react-toastify";

import "../css/scrollbar.css";

import AccessDenied from "../components/AccessDenied";

import AddEditSalesMain from "../Sales/AddEditSalesMain";

import Sales from "../Sales/Sales";
import OpenTransactions from "../Sales/OpenTransactions";
import OpenCashDrawer from "../Sales/OpenCashDrawer";
import { useLottie } from "lottie-react";
import nutechanimation from "../nutech.json";
import { useDispatch, useSelector } from "react-redux";
import { setSales } from "../features/sales/salesSlice";
const POSMain = (props) => {
  const bearer = {
    headers: {
      Authorization: "Bearer " + sessionStorage.getItem("hash"),
    },
  };
  let intTotalDiscountRate = useSelector((state) => state.sales.discountrate);
  let sDiscountType = useSelector((state) => state.sales.discounttype);
  let sDiscountCode = useSelector((state) => state.sales.discountcode);
  let sCustomerTicket = useSelector((state) => state.sales.customerticket);
  let sTransactionDate = useSelector((state) => state.sales.transactiondate);
  const useMountEffect = (functionName) => useEffect(functionName, []);

  const [transactiondate, settransactiondate] = useState("");
  const [discount, setdiscount] = useState("NO DISCOUNT");
  const [discountcode, setdiscountcode] = useState("");
  const [discountrate, setdiscountrate] = useState("");
  const dispatch = useDispatch();
  const ClearFields = () => {
    setdiscount("NO DISCOUNT");
    setdiscountcode("");
    setdiscountrate("");
  };

  const [showPreloader, setPreloader] = useState("normal");

  const [discountLimit, setDiscountLimit] = useState(0);
  const [discountInWeek, setDiscountInWeek] = useState(0);
  function getdiscountinweek() {
    Axios.get(
      props.apiServer + "/getdiscountinweek?par=" + sCustomerTicket,
      bearer
    )
      .then((res) => {
        setDiscountInWeek(0);
        setDiscountInWeek(res.data[0].totaldiscount);
        setDiscountInWeek(res.data[0].totaldiscount);
        setDiscountLimit(0);
        setDiscountLimit(res.data[0].scdiscountlimit);
      })

      .catch((error) => {
        console.log(error);
      });
  }

  const [totalSales, setTotalSales] = useState(0);

  function checkTotalSales() {
    Axios.get(props.apiServer + "/gettotalsales?par=" + sCustomerTicket, bearer)
      .then((res) => {
        setTotalSales(0);
        setTotalSales(res.data[0].totalprice);

        dispatch(setSales(res.data[0].totalprice));
        // console.log("Check Total Sales called");
      })
      .catch((error) => {
        console.log(error);
      });
  }

  const toastId = React.useRef(null);

  const notify = (message) => {
    toastId.current = toast.info(message);
  };

  function fNewTransaction() {
    setTotalSales(0);
    toggleAddEdit();
  }

  const [modalAddEdit, showAddEdit] = useState(false);
  const toggleAddEdit = (transtype) => {
    // ClearFields();
    showAddEdit(!modalAddEdit);
  };

  const [modalOpenTransaction, showOpenTransaction] = useState(false);
  const toggleOpenTransaction = (transtype) => {
    showOpenTransaction(!modalOpenTransaction);
  };

  const [modalOpenCashDrawer, showOpenCashDrawer] = useState(false);
  const toggleOpenCashDrawer = (transtype) => {
    showOpenCashDrawer(!modalOpenCashDrawer);
  };

  function opencpdnew(brand, amount, total) {
    if (total <= 0) {
      return;
    }

    return;
    Axios.get(
      props.apiServerPOS +
        "/opencpd?brand=" +
        brand +
        "&amount=" +
        amount +
        "&total=" +
        total
    )
      .then((res) => {
        if (res.data.status === "1") {
          console.log(props.totalSales);
        } else {
          console.log("CPD Connection Failed!");
        }
      })
      .catch((error) => {
        console.log("CPD Connection Failed!");
      });
  }

  const options = {
    animationData: nutechanimation,
    loop: true,
    h: 1000,
  };
  const { View } = useLottie(options);

  return (
    <React.Fragment>
      <MDBContainer className="pt-4 mb-0 pb-0" fluid>
        <MDBRow className="mt-0 pt-0">
          <MDBCol md="8" lg="8" xs="12" sm="12">
            <h5
              style={{ fontFamily: "Montserrat", fontWeight: "900" }}
              className="display-4 blue-text ml-1"
            >
              {" "}
              CASHIER
            </h5>
          </MDBCol>
          <MDBCol lg="4" md="4" sm="12" xs="12" className="text-center pt-3">
            <MDBBtnGroup>
              <MDBBtn
                className="mb-5"
                color="primary"
                type="button"
                title="Add Customer Ticket"
                size="sm"
                onClick={fNewTransaction}
              >
                <MDBIcon icon="plus" size="2x" className="pr-2" />
              </MDBBtn>
              <MDBBtn
                className="mb-5"
                color="primary"
                type="submit"
                title="Open Previous Transactions"
                size="sm"
                onClick={toggleOpenTransaction}
              >
                <MDBIcon icon="history" size="2x" className="pr-2" />
              </MDBBtn>
              {/*
              DISABLED because nutech has no thermal Printer
              <MDBBtn
                className="mb-5"
                color="success"
                type="submit"
                title="Open Cash Drawer"
                size="sm"
                onClick={toggleOpenCashDrawer}
              >
                <MDBIcon icon="cash-register" size="2x" className="pr-2" />
              </MDBBtn> */}
            </MDBBtnGroup>
          </MDBCol>
        </MDBRow>
      </MDBContainer>

      {sCustomerTicket === "new" ? (
        <MDBContainer className="text-center pb-0 mb-0 pt-0 mt-0" fluid>
          <MDBRow>
            {/* <MDBCol md="4"></MDBCol> */}
            <MDBCol md="6">
              <div className="w-100 pt-0 mt-0 pb-0 mb-0">{View}</div>
              <hr className="my-2" />
            </MDBCol>

            <MDBCol md="6" className="mt-5">
              <MDBCard className="mt-5 pt-5">
                <MDBCardBody>
                  <img
                    src={props.deployURL + "/nutechoriginal.jpg"}
                    className="img-responsive mb-0 pb-0"
                    width="280"
                  />
                  <hr />
                  <p className="lead font-weight-bold brown-text">
                    Vehicle Maintenance Tracking and Monitoring System
                  </p>

                  <p>To begin your transaction,</p>
                  <h5 className="red-text font-weight-bold">
                    Create a Customer Ticket.
                  </h5>
                  <p className="lead">
                    <MDBBtn color="primary" onClick={toggleAddEdit}>
                      Create Now
                    </MDBBtn>
                  </p>
                </MDBCardBody>
              </MDBCard>
            </MDBCol>
          </MDBRow>
        </MDBContainer>
      ) : (
        <MDBCard className="pt-0 mt-0">
          <MDBCardHeader
            // className="cloudy-knoxville-gradient"
            className="primary-color"
          >
            <span className="white-text font-weight-bold">Customer Ticket</span>
            <span className="white-text">
              {" "}
              <b> {sCustomerTicket}</b> &nbsp; | &nbsp;
              {/* <b> {discount} </b> */}
              <b> {sDiscountType} </b> &nbsp; | &nbsp;
              {/* {intTotalDiscountRate}{" "} */}
              <b>
                {" "}
                {sTransactionDate} &nbsp;
                {/* //APPLICABLE TO POS ONLY */}
                {/* <span className="white-text">
                  Discount Limit: &nbsp; {discountLimit}{" "}
                </span>
                &nbsp; | &nbsp; Discount Consumed: &nbsp; {discountInWeek} */}
              </b>
            </span>
          </MDBCardHeader>
          <MDBCardBody>
            <Sales
              deployURL={props.deployURL}
              apiServer={props.apiServer}
              code={sCustomerTicket}
              parentcode={sCustomerTicket}
              apiServerHybrid={props.apiServerHybrid}
              apiServerPOS={props.apiServerPOS}
              discountLimit={discountLimit}
              // discountcode={discountcode}
              // discounttype={discount}
              // discountrate={discountrate}

              discountcode={sDiscountCode}
              discounttype={sDiscountType}
              discountrate={intTotalDiscountRate}
              totalSales={totalSales}
              setTotalSales={setTotalSales}
              checkTotalSales={checkTotalSales}
              discountInWeek={discountInWeek}
              setDiscountInWeek={setDiscountInWeek}
              getdiscountinweek={getdiscountinweek}
              toggleModal={toggleAddEdit}
              opencpdnew={opencpdnew}
            ></Sales>
          </MDBCardBody>
        </MDBCard>
      )}

      <MDBModal
        backdrop={false}
        isOpen={modalAddEdit}
        toggleModal={toggleAddEdit}
        fullHeight
        position="right"
        size="lg"
      >
        <MDBCard>
          <MDBCardHeader className="primary-color">
            <h5 className="h5-responsive white-text">
              <MDBIcon icon="shopping-cart" />
              &nbsp;<b>Add Customer Ticket</b>
            </h5>
          </MDBCardHeader>
          <MDBCardBody>
            <AddEditSalesMain
              deployURL={props.deployURL}
              apiServer={props.apiServer}
              code={"new"}
              totalSales={0}
              setTotalSales={setTotalSales}
              checkTotalSales={checkTotalSales}
              discountLimit={discountLimit}
              discountInWeek={discountInWeek}
              setDiscountInWeek={setDiscountInWeek}
              getdiscountinweek={getdiscountinweek}
              apiServerHybrid={props.apiServerHybrid}
              toggleModal={toggleAddEdit}
              ClearFields={ClearFields}
              opencpdnew={opencpdnew}
            ></AddEditSalesMain>
          </MDBCardBody>
        </MDBCard>
      </MDBModal>

      <MDBModal
        backdrop={false}
        isOpen={modalOpenTransaction}
        toggleModal={toggleOpenTransaction}
        // fullHeight
        // position="bottom"
        size="fluid"
      >
        <MDBCard>
          <MDBCardHeader className="primary-color">
            <h5 className="h5-responsive white-text">
              <MDBIcon icon="shopping-cart" />
              &nbsp;<b>Open Previous Transaction</b>
            </h5>
          </MDBCardHeader>
          <MDBCardBody>
            <OpenTransactions
              deployURL={props.deployURL}
              apiServer={props.apiServer}
              code={"new"}
              settransactiondate={settransactiondate}
              ClearFields={ClearFields}
              apiServerHybrid={props.apiServerHybrid}
              toggleModal={toggleOpenTransaction}
            ></OpenTransactions>
          </MDBCardBody>
        </MDBCard>
      </MDBModal>

      <MDBModal
        backdrop={false}
        isOpen={modalOpenCashDrawer}
        toggleModal={toggleOpenCashDrawer}
        fullHeight
        position="right"
        size="lg"
      >
        <MDBCard>
          <MDBCardHeader className="primary-color">
            <h5 className="h5-responsive white-text">
              <MDBIcon icon="shopping-cart" />
              &nbsp;<b>Open Cash Drawer</b>
            </h5>
          </MDBCardHeader>
          <MDBCardBody>
            <OpenCashDrawer
              deployURL={props.deployURL}
              apiServer={props.apiServer}
              code={"new"}
              settransactiondate={settransactiondate}
              setdiscount={setdiscount}
              setdiscountcode={setdiscountcode}
              setdiscountrate={setdiscountrate}
              apiServerPOS={props.apiServerPOS}
              apiServerHybrid={props.apiServerHybrid}
              toggleModal={toggleOpenCashDrawer}
            ></OpenCashDrawer>
          </MDBCardBody>
        </MDBCard>
      </MDBModal>
      {/* <ToastContainer
        hideProgressBar={true}
        newestOnTop={true}
        autoClose={5000}
      /> */}
      {/*    <ToastContainer
                        hideProgressBar={true}
                        newestOnTop={true}
                        autoClose={5000}
                    /> */}
    </React.Fragment>
  );
};

export default POSMain;
